import React from 'react'
import styles from './style/properties_style.module.scss'
import Foundation from '../../design-system/foundations/Foundation'
import Button from '../../design-system/basics/button/Button'
import Property from '../../design-system/moleculars/property/Property'
import Typography from '../../design-system/foundations/typography/Typography'
import Translation from '../../global/Translation'
import LocalizedLink from '../../global/LocalizedLink'
import { STONES_FAMILIES } from '../NaturalStoneHelper'

const Properties = ({ family='Granite', intl, languageDir }) => {

    const LEVELS = {
        Granite: {
            hardness: 4,
            weather_resistance: 4,
            porosity: 1,
            absortion: 1,
            scratch_resistance: 5,
            thermal_shock_resistance: 4,
            compression_resistance: 3,
            flexural_resistance: 4,
            chemical_attack: 4
        },
        Quartzite: {
            hardness: 4,
            weather_resistance: 4,
            porosity: 1,
            absortion: 1,
            scratch_resistance: 5,
            thermal_shock_resistance: 4,
            compression_resistance: 0,
            flexural_resistance: 4,
            chemical_attack: 4
        },
        Marble: {
            hardness: 2,
            weather_resistance: 3,
            porosity: 2,
            absortion: 1,
            scratch_resistance: 3,
            thermal_shock_resistance: 3,
            compression_resistance: 3,
            flexural_resistance: 3,
            chemical_attack: 3
        },
        Limestone: {
            hardness: 2,
            weather_resistance: 3,
            porosity: 3,
            absortion: 3,
            scratch_resistance: 2,
            thermal_shock_resistance: 2,
            compression_resistance: 3,
            flexural_resistance: 3,
            chemical_attack: 2
        },
        Travertine: {
            hardness: 2,
            weather_resistance: 4,
            porosity: 5,
            absortion: 5,
            scratch_resistance: 2,
            thermal_shock_resistance: 2,
            compression_resistance: 2,
            flexural_resistance: 2,
            chemical_attack: 1
        },
        Sandstone: {
            hardness: 2,
            weather_resistance: 1,
            porosity: 4,
            absortion: 4,
            scratch_resistance: 2,
            thermal_shock_resistance: 2,
            compression_resistance: 1,
            flexural_resistance: 2,
            chemical_attack: 2
        },
        Onyx: {
            hardness: 3,
            weather_resistance: 3,
            porosity: 2,
            absortion: 1,
            scratch_resistance: 3,
            thermal_shock_resistance: 3,
            compression_resistance: 3,
            flexural_resistance: 3,
            chemical_attack: 3
        }
    }

    const getLinkButtonText = () => {
        switch (family) {
            case "Granite":
                return <Translation id="view_all_granite" defaultMessage="View all granite"/>
            case "Marble":
                return <Translation id="view_all_marble" defaultMessage="View all marble"/>
            case "Travertine":
                return <Translation id="view_all_travertine" defaultMessage="View all travertine"/>
            case "Quartzite":
                return <Translation id="view_all_quartzite" defaultMessage="View all quartzite"/>
            case "Onyx":
                return <Translation id="view_all_onyx" defaultMessage="View all onyx"/>
            case "Limestone":
                return <Translation id="view_all_limestone" defaultMessage="View all limestone"/>
            case "Sandstone":
                return <Translation id="view_all_sandstone" defaultMessage="View all sandstone"/>
        }
    }


    return (
        <Foundation back-accent-50>
            <div className={`${styles['properties']}`}>
                <div className={styles['properties-title']}>
                    <Typography typeface="title-m-medium">
                        <Translation id="properties_of_stone_type" defaultMessage="Properties of {stone_type}:" values={{ stone_type:intl.formatMessage({id:family.toLowerCase()})}} />
                    </Typography>
                </div>

                <div className={styles['properties-progress-bars']}>
                    <div className={styles['properties-progress-bar-column']}>
                        <React.Fragment>

                        <Property level={LEVELS[family].hardness}>
                            <Translation id="hardness" defaultMessage="Hardness"/>
                        </Property>
                        <Property level={LEVELS[family].weather_resistance}>
                            <Translation id="weather_resistance" defaultMessage="Weather Resistance"/>
                        </Property>
                        <Property level={LEVELS[family].porosity}>
                            <Translation id="porosity" defaultMessage="Porosity"/>
                        </Property>
                        </React.Fragment>
                    </div>
                    <div className={styles['properties-progress-bar-column']}>
                        <Property level={LEVELS[family].absortion}>
                            <Translation id="absortion" defaultMessage="Absortion"/>
                        </Property>
                        <Property level={LEVELS[family].scratch_resistance}>
                            <Translation id="scratch_resistance" defaultMessage="Scrath Resistance"/>
                        </Property>
                        <Property level={LEVELS[family].thermal_shock_resistance}>
                            <Translation id="thermal_shock_resistance" defaultMessage="Thermal Shock Resistance"/>
                        </Property>
                    </div>
                    <div className={styles['properties-progress-bar-column']}>
                        <Property level={LEVELS[family].compression_resistance}>
                            <Translation id="compression_resistance" defaultMessage="Compression Resistance"/>
                        </Property>
                        <Property level={LEVELS[family].flexural_resistance}>
                            <Translation id="flexural_resistance" defaultMessage="Flexural Resistance"/>
                        </Property>
                        <Property level={LEVELS[family].chemical_attack}>
                            <Translation id="chemical_attack_stained" defaultMessage="Chemical Attack / Stained"/>
                        </Property>
                    </div>
                </div>

                <div className={styles['properties-button-container']}>
                    <LocalizedLink routeId='ROUTE_CATALOG'
                                   queryString={`?brand[0]=SCALEA&brand[1]=SENSA&type[0]=SLAB&family[0]=${STONES_FAMILIES[family]}`}
                                   params={{'outlet': 'hq'}}
                    >
                        <Button style-white
                                size-l
                                img="arrow_short"
                                hImg="arrow_large"
                                img={languageDir === 'rtl' ? "arrow_short_inverse" : "arrow_short"}
                                hImg={languageDir === 'rtl' ? "arrow_large_inverse" : "arrow_large"}
                        >
                            { getLinkButtonText() }
                        </Button>
                    </LocalizedLink>


                </div>
            </div>
        </Foundation>
    )
};

Properties.propTypes = {

}

export default Properties;